import React from "react";
function HeaderLower() {
  return (
    <div className="header_lower">
    Try a Casper and Enter to Win!
    </div>
  );
}
export default HeaderLower;
